import React, { useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useUser } from '../../hooks/useUser'
import { setScreenshotMode } from '../../actions/user'
import { Menu, MenuItem } from '../ui/menu'
import { CSVExportMenuItem } from '../ui/ExportCSV'
import { Params } from '../../packages/blueprint-components/src/useTableHooks'
import { EllipsisMenu } from '../../icons/icons'

interface RightMenuProps {
    params: Params
    // This should be an array of MenuItems
    extraMenuItems?: JSX.Element[]
}

export const RightMenu = ({ params, extraMenuItems }: RightMenuProps): JSX.Element | null => {
    const menuItems = useMemo(
        () => (
            <Menu>
                {extraMenuItems}
                <CSVExportMenuItem params={params} />
                <ScreenshotMode />
            </Menu>
        ),
        [params],
    )

    return (
        <div className="flex items-center justify-center h-full mr-2">
            <div className="cursor-pointer flex items-center h-full">
                <EllipsisMenu content={menuItems} />
            </div>
        </div>
    )
}

const ScreenshotMode = () => {
    const dispatch = useDispatch()
    const { screenshotMode } = useUser()

    const handleClick = () => {
        dispatch(setScreenshotMode())
    }

    return (
        <MenuItem
            text={screenshotMode ? 'Disable Screenshot Mode' : 'Enable Screenshot Mode'}
            onClick={handleClick}
        />
    )
}
